import React from 'react';
import DataTable from './DataTable'; // Import the DataTable component

const HardwareList = ({ onHardwareSelect, selectedHardware, takenByState, setTakenByState }) => {
  return (
    <DataTable title="Hardware List" onHardwareSelect={onHardwareSelect} selectedHardware={selectedHardware} takenBy={takenByState} onTakenByChange={(event, row) => setTakenByState((prevTakenBy) => ({ ...prevTakenBy, [`${row['Customer Name']}-${row['Serial No']}-${row['Date']}`]: event.target.value }))} /> // Render the DataTable component with the title prop
  );
};

export default HardwareList;